// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__LKfQJ","rightAdornment":"Header_rightAdornment__3y3Gg"};